import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'backdrop', 'content', 'submitButton']
  static values = { reopen: Boolean }

  connect() {
    this.validate()

    // A failed server-side submission re-renders the page with the modal
    // closed; reopen it so the tester sees the error next to their input.
    if (this.reopenValue) {
      this.open()
    }
  }

  open() {
    this.modalTarget.classList.remove('hidden')

    // Hiding the body's scrollbar frees its width, shifting the whole page;
    // reserve the same width as padding so the layout stays put.
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.overflow = 'hidden'
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }

    // Trigger fade in animation
    requestAnimationFrame(() => {
      this.modalTarget.classList.remove('opacity-0')
      this.modalTarget.classList.add('opacity-100')

      // Animate content panel
      if (this.hasContentTarget) {
        this.contentTarget.classList.remove('opacity-0', 'scale-95')
        this.contentTarget.classList.add('opacity-100', 'scale-100')
      }
    })
  }

  close() {
    // Trigger fade out animation
    this.modalTarget.classList.remove('opacity-100')
    this.modalTarget.classList.add('opacity-0')

    // Animate content panel out
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('opacity-100', 'scale-100')
      this.contentTarget.classList.add('opacity-0', 'scale-95')
    }

    // Wait for transition to complete before hiding
    setTimeout(() => {
      this.modalTarget.classList.add('hidden')
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }, 200)
  }

  handleBackdropClick(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    if (this.isFormValid()) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
    }
  }

  isFormValid() {
    const scenario = this.element.querySelector(
      'textarea[name="field_test[scenario]"]'
    )
    const currentSelected = this.element.querySelector(
      'input[name="field_test[current]"]:checked'
    )
    const concernsSelected = this.element.querySelectorAll(
      'input[name="field_test[concern_ids][]"]:checked'
    )

    return Boolean(
      scenario?.value.trim() && currentSelected && concernsSelected.length > 0
    )
  }
}
